import React from 'react';

const SubHeading = (props) => {
    return (
        <h3 className="text-white text-uppercase mb-4">{props.title}</h3>
    );
};

export default SubHeading;